<template>
  <div class="about-page">
    <NavBar />
    
    <div class="page-container">
      <!-- 页面标题 -->
      <div class="page-header">
        <span class="back-link" @click="$router.push('/')">← 返回首页</span>
        <h1 class="page-title">{{ pageData.title || '关于我们' }}</h1>
      </div>
      
      <!-- 富文本内容 -->
      <div class="content-section" v-if="pageData.content" v-html="pageData.content"></div>
      
      <!-- 联系信息 -->
      <!-- <div class="contact-section">
        <h2 class="section-title">联系方式</h2>
        <div class="contact-list">
          <div class="contact-row">
            <span class="contact-label">公司地址</span>
            <span class="contact-value">{{ siteConfig.company_address || '-' }}</span>
          </div>
          <div class="contact-row">
            <span class="contact-label">联系电话</span>
            <span class="contact-value">{{ siteConfig.contact_phone || '-' }}</span>
          </div>
          <div class="contact-row">
            <span class="contact-label">工作时间</span>
            <span class="contact-value">周一至周日 9:00-21:00</span>
          </div>
        </div>
      </div> -->
      
      <!-- 留言表单 -->
      <div class="form-section">
        <h2 class="section-title">留言咨询</h2>
        <div class="form-wrap">
          <div class="form-row">
            <label class="form-label">姓名 <span class="required">*</span></label>
            <input 
              type="text" 
              class="form-input" 
              v-model="messageForm.name" 
              placeholder="请输入您的姓名"
            />
          </div>
          <div class="form-row">
            <label class="form-label">邮箱</label>
            <input 
              type="email" 
              class="form-input" 
              v-model="messageForm.email" 
              placeholder="请输入您的邮箱（选填）"
            />
          </div>
          <div class="form-row">
            <label class="form-label">留言 <span class="required">*</span></label>
            <textarea 
              class="form-textarea" 
              v-model="messageForm.message" 
              placeholder="请输入您的留言内容..."
              rows="4"
            ></textarea>
          </div>
          <button class="submit-btn" @click="handleSubmit">提交</button>
        </div>
      </div>
    </div>
    
    <Footer />
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import Footer from '@/components/Footer.vue'
import { getPageDetail, getSiteConfig } from '@/api/index.js'

export default {
  name: 'AboutPage',
  components: {
    NavBar,
    Footer
  },
  data() {
    return {
      pageData: {},
      siteConfig: {},
      messageForm: {
        name: '',
        email: '',
        message: ''
      }
    }
  },
  mounted() {
    this.loadPageContent()
    this.loadSiteConfig()
  },
  methods: {
    async loadPageContent() {
      try {
        const result = await getPageDetail('about')
        if (result.code === 1 && result.data) {
          this.pageData = result.data
        }
      } catch (error) {
        console.error('加载页面内容失败:', error)
      }
    },
    async loadSiteConfig() {
      try {
        const result = await getSiteConfig()
        if (result.code === 1 && result.data) {
          this.siteConfig = result.data
        }
      } catch (error) {
        console.error('加载网站配置失败:', error)
      }
    },
    handleSubmit() {
      if (!this.messageForm.name) {
        this.$message.warning('请输入您的姓名')
        return
      }
      if (this.messageForm.email) {
        const emailReg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        if (!emailReg.test(this.messageForm.email)) {
          this.$message.warning('请输入正确的邮箱格式')
          return
        }
      }
      if (!this.messageForm.message) {
        this.$message.warning('请输入留言内容')
        return
      }
      
      // TODO: 调用留言API
      this.$message.success('留言已提交，我们会尽快回复您！')
      // 清空表单
      this.messageForm = {
        name: '',
        email: '',
        message: ''
      }
    }
  }
}
</script>

<style scoped>
.about-page {
  min-height: 100vh;
  background: #fff;
}

.page-container {
  max-width: 700px;
  margin: 0 auto;
  padding: 40px 24px 80px;
}

.page-header {
  margin-bottom: 50px;
}

.back-link {
  font-size: 14px;
  color: #666;
  cursor: pointer;
  display: inline-block;
  margin-bottom: 20px;
  transition: color 0.2s;
}

.back-link:hover {
  color: #111;
}

.page-title {
  font-size: 32px;
  font-weight: 800;
  color: #111;
  margin: 0;
  padding-bottom: 16px;
  border-bottom: 2px solid #111;
}

.content-section {
  margin-bottom: 50px;
  padding-bottom: 50px;
  border-bottom: 1px solid #eee;
}

.content-section :deep(p) {
  font-size: 15px;
  line-height: 1.8;
  color: #444;
  margin-bottom: 16px;
}

.content-section :deep(h2) {
  font-size: 20px;
  font-weight: 700;
  color: #111;
  margin: 32px 0 16px 0;
}

.content-section :deep(h3) {
  font-size: 17px;
  font-weight: 600;
  color: #111;
  margin: 24px 0 12px 0;
}

.section-title {
  font-size: 20px;
  font-weight: 700;
  color: #111;
  margin: 0 0 24px 0;
}

.contact-section {
  margin-bottom: 50px;
  padding-bottom: 50px;
  border-bottom: 1px solid #eee;
}

.contact-list {
  display: flex;
  flex-direction: column;
}

.contact-row {
  display: flex;
  padding: 14px 0;
  border-bottom: 1px solid #f0f0f0;
}

.contact-row:last-child {
  border-bottom: none;
}

.contact-label {
  width: 100px;
  flex-shrink: 0;
  font-size: 14px;
  color: #999;
}

.contact-value {
  flex: 1;
  font-size: 15px;
  color: #111;
}

.form-section {
  margin-bottom: 40px;
}

.form-wrap {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-row {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-label {
  font-size: 14px;
  font-weight: 500;
  color: #111;
}

.form-label .required {
  color: #e00;
}

.form-input,
.form-textarea {
  width: 100%;
  padding: 12px 14px;
  font-size: 15px;
  border: 1px solid #ddd;
  outline: none;
  transition: border-color 0.2s;
  font-family: inherit;
}

.form-input:focus,
.form-textarea:focus {
  border-color: #111;
}

.form-textarea {
  resize: vertical;
  min-height: 100px;
}

.submit-btn {
  width: 100%;
  padding: 14px;
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  background: #111;
  border: none;
  cursor: pointer;
  transition: opacity 0.2s;
}

.submit-btn:hover {
  opacity: 0.8;
}

@media (max-width: 768px) {
  .page-container {
    padding: 24px 16px 60px;
  }
  
  .page-title {
    font-size: 26px;
  }
  
  .contact-row {
    flex-direction: column;
    gap: 4px;
  }
  
  .contact-label {
    width: auto;
  }
}
</style>
